import { render, staticRenderFns } from "./Orchid.vue?vue&type=template&id=6dc5bd49&"
import script from "./Orchid.vue?vue&type=script&lang=js&"
export * from "./Orchid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports